import { render, staticRenderFns } from "./MonederosRestaurante.vue?vue&type=template&id=0c31b951"
import script from "./MonederosRestaurante.vue?vue&type=script&lang=js"
export * from "./MonederosRestaurante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports